import { useState, useCallback } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Products } from "@/components/Products";
import { About } from "@/components/About";
import { EnquiryForm } from "@/components/EnquiryForm";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [enquiryService, setEnquiryService] = useState("");

  const handleEnquire = useCallback((serviceId) => {
    setEnquiryService(serviceId);
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div id="top" className="min-h-screen bg-background text-foreground">
      <Navbar />
      <Hero />
      <Services onEnquire={handleEnquire} />
      <Products onEnquire={handleEnquire} />
      <About />
      <EnquiryForm selectedService={enquiryService} />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
